export default __webpack_public_path__ + "static/media/9.9b4c8ec2.png";